// @hssna/family-web — 家属门户入口
// 战役 0 (T0-03): 接入 React Router 6 Data Router (ADR-0011)
// 战役 2 (T2-01): 注入 QueryClientProvider + AuthClient + auth-store
//
// 规格: SPEC §4.1 API 客户端架构 / §8.1 family-web 功能规格

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthClient } from '@hssna/ts-shared';
import { router } from './routes';
import { useAuthStore } from './store/auth-store';
import './styles.css';

// S1 Identity API 基础 URL (默认 /api, 由 nginx 反代到 S1)
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '/api';

const authClient = new AuthClient({ baseUrl: apiBaseUrl });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const root = createRoot(document.getElementById('root')!);

// 初始化 auth-store: 注入 AuthClient 并尝试从 TokenStore 恢复已登录会话
// 完成后再挂载 React, 避免 RequireAuth 在会话恢复前误判为未认证
void useAuthStore
  .getState()
  .init(authClient)
  .finally(() => {
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </StrictMode>,
    );
  });
